import { Component,OnInit } from '@angular/core';
import { APPCONFIG } from '../config';
import { FormGroup, FormBuilder, FormControl,FormArray, Validators } from '@angular/forms';
import { Router,ActivatedRoute } from '@angular/router';
import { CommonService } from '../shared/services/common.service';
import { SessionHandler } from '../shared/services/session-handler.service';
import { HttpService } from '../shared/services/http.service'
import { MdDialog,MdDialogRef } from '@angular/material';
import { dialogComponent } from '../dialog/dialog.component';
import * as $ from 'jquery';
import { addApproverComponent } from './addApprover.component';

@Component({
    template: require('./admin.component.html'),
    styles: [require('./admin.component.scss')]
})

export class adminComponent {

    dialogRef;
    isOTD: boolean = false;
    userData:any;
    isAdmin:boolean = false;
    approverList:any = [];
    approverMailList:any;
    constructor(private router: Router,private commonService : CommonService,private route: ActivatedRoute,private sessionHandler:SessionHandler,
    private http:HttpService,private dialog: MdDialog,private formBuilder: FormBuilder,) {
        if(this.http.checkSession()){
            this.userData = JSON.parse(this.sessionHandler.getItem('loginData'));
            if(this.userData && this.userData.role && this.userData.role.length > 0){
                if(this.userData.role.includes('ADMIN')) {
                    this.isAdmin = true;
                    this.getUserList();
                    this.getApproverList();
                } 
                else if (this.userData.role.includes('OTD_APPROVER')) {
                    this.isOTD = true;
                    this.getUserList();
                    this.getApproverList();
                }
                else {
                    this.dialogRef = this.dialog.open(dialogComponent,{disableClose:true});
                    this.dialogRef.componentInstance.msg = 'You are not authorized to access this page.';
                    this.dialogRef.afterClosed().subscribe(result => {
                        this.router.navigateByUrl('/app/dashboard');
                        this.dialogRef = null;
                    });
                }

                // *****Old Role logic*****************
                // for(let u in this.userData.role){
                //     if(this.userData.role[u] == 'ADMIN') {
                //         this.isAdmin = true;
                //         this.getUserList();
                //         this.getApproverList();
                //     } 
                //     else if (this.userData.role[u] == 'OTD_APPROVER') {
                //         this.isOTD = true;
                //         this.getUserList();
                //         this.getApproverList();
                //     }
                //     else {
                //         this.dialogRef = this.dialog.open(dialogComponent,{disableClose:true});
                //         this.dialogRef.componentInstance.msg = 'You are not authorized to access this page.';
                //         this.dialogRef.afterClosed().subscribe(result => {
                //             this.router.navigateByUrl('/app/dashboard');
                //             this.dialogRef = null;
                //         });
                //     }
                // }
            }

            this.commonService.approverChange.subscribe((value) => {
                this.dialogRef = this.dialog.open(dialogComponent,{disableClose:true});
                if(value == 'edit'){
                    this.dialogRef.componentInstance.msg = 'Additional approver updated successfully';                    
                } else if(value == 'delete'){
                    this.dialogRef.componentInstance.msg = 'Additional approver deleted successfully';                    
                } else {
                    this.dialogRef.componentInstance.msg = 'Additional approver added successfully';
                }
                this.dialogRef.afterClosed().subscribe(result => {
                    if(result) {
                        this.getUserList();
                    }
                    this.dialogRef = null;
                });
            });
        } else {
            this.http.showSessionError();
        }
    }

    public getApproverList(){
        this.http.showLoader();
        this.http.getRequest('approverOperationsApi/v1/getApproverMailList')
        .subscribe(
            res => {
                this.saveApproverList(res);
                this.http.onEnd();

                },
                err => {
                    if(err && err.status!=0){
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = err;
                        
                    }
                    this.http.onEnd();
        });
    }

    public getUserList(){
        this.http.getRequest('approverOperationsApi/v1/approverList')
        .subscribe(
            res => {
                this.saveList(res);
                this.http.onEnd();

                },
                err => {
                    if(err && err.status!=0){
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = err;
                        
                    }
                    this.http.onEnd();
        });
    }


    public saveApproverList(res){
        if(res.responseCode == '200'){
            this.approverMailList = res.approverList;
        } else {
            this.dialogRef = this.dialog.open(dialogComponent);
            if(res.responseMessage){
                this.dialogRef.componentInstance.msg = res.responseMessage;
            } else {
                this.dialogRef.componentInstance.msg = res.errorMessage;
            }            
        }
    }

    public saveList(res){
        if(res.approverList && Object.keys(res.approverList).length > 0){
            this.approverList = res.approverList;
            // this.http.onEnd();
        } else {
            this.dialogRef = this.dialog.open(dialogComponent);
            if(res.responseMessage){
                this.dialogRef.componentInstance.msg = res.responseMessage;
            } else {
                this.dialogRef.componentInstance.msg = res.errorMessage;
            }
            this.http.onEnd();
        }
    }

    public addApproverDialog(action,role,order,email,fromDate,toDate){
        this.dialogRef = this.dialog.open(addApproverComponent,{disableClose:true});
        this.dialogRef.componentInstance.action = action;
        this.dialogRef.componentInstance.roleType = role;
        this.dialogRef.componentInstance.orderType = order;
        this.dialogRef.componentInstance.approverMailList = this.approverMailList;
        if(action == 'edit' || action == 'delete'){
            this.dialogRef.componentInstance.email = email;
            this.dialogRef.componentInstance.fromDate = fromDate;
            this.dialogRef.componentInstance.toDate = toDate;
        }
        console.log(this.dialogRef)
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin/admin.component.ts